/**
 * Form helpers for create/edit activity type views.
 */
import type {
  ActivityType,
  ActivityTypeFormValues,
  CreateActivityTypeDto,
} from '@/types/activity-type.types';

export type { ActivityTypeFormValues };
import { DEFAULT_CREATE_ACTIVITY_TYPE_FORM } from './activity-type-configs';
import { getErrorMessage } from '@/utils/errors-utils';

/** Values accepted by {@link applyActivityTypeFormField}. */
type ActivityTypeFormFieldValue = string | number | undefined;

/** Fresh create DTO from {@link DEFAULT_CREATE_ACTIVITY_TYPE_FORM}. */
export function emptyCreateActivityTypeForm(): CreateActivityTypeDto {
  return { ...DEFAULT_CREATE_ACTIVITY_TYPE_FORM };
}

/** Immutable patch of one form field. */
export function applyActivityTypeFormField<T extends object>(
  formData: T,
  field: keyof T,
  value: ActivityTypeFormFieldValue,
): T {
  return { ...formData, [field]: value };
}

/** Hydrate the edit form from a GET activity type. */
export function activityTypeToFormData(activityType: ActivityType): ActivityTypeFormValues {
  return {
    code: activityType.code ?? '',
    label: activityType.label,
    description: activityType.description || '',
    status: activityType.status,
  };
}

/** Central error copy from {@link getErrorMessage}. */
export function getActivityTypeApiError(error: unknown, _fallback?: string): string {
  return getErrorMessage(error);
}

/** React Query key for a single activity type. */
export function activityTypeQueryKey(activityTypeId: string) {
  return ['activityType', activityTypeId] as const;
}
